import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { LayoutType } from '../../enums';
import { AppSettingsState } from '../../models/app';
import { deepComputed, patchState, signalState } from '@ngrx/signals';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private _http = inject(HttpClient);
  private _state = signalState<AppSettingsState>({
    layoutType: LayoutType.None,
    isPage: false,
    isPlugin: false,
  });
  state = deepComputed(this._state);

  /**
   * @warning ONLY use appSettings for public global configurations
   */
  load(): Observable<AppSettingsState> {
    return this._http
      .get<AppSettingsState>(`appSettings.json?v=${environment.version}`)
      .pipe(
        tap((settings) => {
          patchState(this._state, (_) => ({
            layoutType: settings.layoutType,
            isPage: settings.layoutType === LayoutType.Page,
            isPlugin: settings.layoutType === LayoutType.Plugin,
          }));
        }),
      );
  }

  changeLayoutType(type?: LayoutType) {
    const layoutType =
      type ||
      (this.state.layoutType() === LayoutType.Page
        ? LayoutType.Plugin
        : LayoutType.Page);

    patchState(this._state, (_) => ({
      layoutType,
      isPage: layoutType === LayoutType.Page,
      isPlugin: layoutType === LayoutType.Plugin,
    }));
  }

  changeTheme(theme: 'light' | 'dark') {
    const html = document.querySelector('html');
    if (html) {
      html.setAttribute('data-theme', theme);

      // Set darkMode tailwind class
      switch (theme) {
        case 'dark': {
          html.setAttribute('data-mode', 'dark');
        }
      }
    }
  }
}
